module.exports = __webpack_public_path__ + "img/map2.7899bbc7.png";